export default {
 "columns": 29,
 "image": "cryolab-hand-rails.png",
 "imageheight": 496,
 "imagewidth": 464,
 "margin": 0,
 "name": "cryolab-hand-rails",
 "spacing": 0,
 "tilecount": 899,
 "tiledversion": "1.11.2",
 "tileheight": 16,
 "tilewidth": 16,
 "type": "tileset",
 "version": "1.10",
 "tiles": [
  {
   "id": 23,
   "type": "decal"
  },
  {
   "id": 30,
   "type": "decal"
  },
  {
   "id": 31,
   "type": "decal"
  },
  {
   "id": 32,
   "type": "decal"
  },
  {
   "id": 36,
   "type": "decal"
  },
  {
   "id": 37,
   "type": "decal"
  },
  {
   "id": 38,
   "type": "decal"
  },
  {
   "id": 39,
   "type": "decal"
  },
  {
   "id": 40,
   "type": "decal"
  },
  {
   "id": 41,
   "type": "decal"
  },
  {
   "id": 42,
   "type": "decal"
  },
  {
   "id": 45,
   "type": "decal"
  },
  {
   "id": 46,
   "type": "decal"
  },
  {
   "id": 47,
   "type": "decal"
  },
  {
   "id": 49,
   "type": "decal"
  },
  {
   "id": 50,
   "type": "decal"
  },
  {
   "id": 51,
   "type": "decal"
  },
  {
   "id": 52,
   "type": "decal"
  },
  {
   "id": 53,
   "type": "decal"
  },
  {
   "id": 54,
   "type": "decal"
  },
  {
   "id": 55,
   "type": "decal"
  },
  {
   "id": 56,
   "type": "decal"
  },
  {
   "id": 57,
   "type": "decal"
  },
  {
   "id": 59,
   "type": "decal"
  },
  {
   "id": 60,
   "type": "decal"
  },
  {
   "id": 61,
   "type": "decal"
  },
  {
   "id": 62,
   "type": "decal"
  },
  {
   "id": 63,
   "type": "decal"
  },
  {
   "id": 64,
   "type": "decal"
  },
  {
   "id": 65,
   "type": "decal"
  },
  {
   "id": 66,
   "type": "decal"
  },
  {
   "id": 67,
   "type": "decal"
  },
  {
   "id": 68,
   "type": "decal"
  },
  {
   "id": 69,
   "type": "decal"
  },
  {
   "id": 70,
   "type": "decal"
  },
  {
   "id": 71,
   "type": "decal"
  },
  {
   "id": 74,
   "type": "decal"
  },
  {
   "id": 75,
   "type": "decal"
  },
  {
   "id": 76,
   "type": "decal"
  },
  {
   "id": 77,
   "type": "decal"
  },
  {
   "id": 78,
   "type": "decal"
  },
  {
   "id": 79,
   "type": "decal"
  },
  {
   "id": 80,
   "type": "decal"
  },
  {
   "id": 81,
   "type": "decal"
  },
  {
   "id": 82,
   "type": "decal"
  },
  {
   "id": 83,
   "type": "decal"
  },
  {
   "id": 84,
   "type": "decal"
  },
  {
   "id": 85,
   "type": "decal"
  },
  {
   "id": 86,
   "type": "decal"
  },
  {
   "id": 88,
   "type": "decal"
  },
  {
   "id": 89,
   "type": "decal"
  },
  {
   "id": 90,
   "type": "decal"
  },
  {
   "id": 91,
   "type": "decal"
  },
  {
   "id": 92,
   "type": "decal"
  },
  {
   "id": 93,
   "type": "decal"
  },
  {
   "id": 94,
   "type": "decal"
  },
  {
   "id": 95,
   "type": "decal"
  },
  {
   "id": 96,
   "type": "decal"
  },
  {
   "id": 97,
   "type": "decal"
  },
  {
   "id": 98,
   "type": "decal"
  },
  {
   "id": 99,
   "type": "decal"
  },
  {
   "id": 100,
   "type": "decal"
  },
  {
   "id": 101,
   "type": "decal"
  },
  {
   "id": 112,
   "type": "decal"
  },
  {
   "id": 143,
   "type": "decal"
  },
  {
   "id": 163,
   "type": "decal"
  },
  {
   "id": 164,
   "type": "decal"
  },
  {
   "id": 171,
   "type": "decal"
  },
  {
   "id": 172,
   "type": "decal"
  },
  {
   "id": 180,
   "type": "decal"
  },
  {
   "id": 181,
   "type": "decal"
  },
  {
   "id": 185,
   "type": "decal"
  },
  {
   "id": 186,
   "type": "decal"
  },
  {
   "id": 192,
   "type": "decal"
  },
  {
   "id": 193,
   "type": "decal"
  },
  {
   "id": 194,
   "type": "decal"
  },
  {
   "id": 199,
   "type": "decal"
  },
  {
   "id": 200,
   "type": "decal"
  },
  {
   "id": 201,
   "type": "decal"
  },
  {
   "id": 208,
   "type": "decal"
  },
  {
   "id": 209,
   "type": "decal"
  },
  {
   "id": 210,
   "type": "decal"
  },
  {
   "id": 211,
   "type": "decal"
  },
  {
   "id": 213,
   "type": "decal"
  },
  {
   "id": 214,
   "type": "decal"
  },
  {
   "id": 215,
   "type": "decal"
  },
  {
   "id": 216,
   "type": "decal"
  },
  {
   "id": 217,
   "type": "decal"
  },
  {
   "id": 222,
   "type": "decal"
  },
  {
   "id": 223,
   "type": "decal"
  },
  {
   "id": 224,
   "type": "decal"
  },
  {
   "id": 227,
   "type": "decal"
  },
  {
   "id": 228,
   "type": "decal"
  },
  {
   "id": 229,
   "type": "decal"
  },
  {
   "id": 232,
   "type": "decal"
  },
  {
   "id": 233,
   "type": "decal"
  },
  {
   "id": 234,
   "type": "decal"
  },
  {
   "id": 235,
   "type": "decal"
  },
  {
   "id": 237,
   "type": "decal"
  },
  {
   "id": 238,
   "type": "decal"
  },
  {
   "id": 239,
   "type": "decal"
  },
  {
   "id": 240,
   "type": "decal"
  },
  {
   "id": 242,
   "type": "decal"
  },
  {
   "id": 243,
   "type": "decal"
  },
  {
   "id": 244,
   "type": "decal"
  },
  {
   "id": 245,
   "type": "decal"
  },
  {
   "id": 246,
   "type": "decal"
  },
  {
   "id": 252,
   "type": "decal"
  },
  {
   "id": 253,
   "type": "decal"
  },
  {
   "id": 254,
   "type": "decal"
  },
  {
   "id": 255,
   "type": "decal"
  },
  {
   "id": 256,
   "type": "decal"
  },
  {
   "id": 257,
   "type": "decal"
  },
  {
   "id": 261,
   "type": "decal"
  },
  {
   "id": 262,
   "type": "decal"
  },
  {
   "id": 263,
   "type": "decal"
  },
  {
   "id": 264,
   "type": "decal"
  },
  {
   "id": 266,
   "type": "decal"
  },
  {
   "id": 269,
   "type": "decal"
  },
  {
   "id": 272,
   "type": "decal"
  },
  {
   "id": 273,
   "type": "decal"
  },
  {
   "id": 282,
   "type": "decal"
  },
  {
   "id": 283,
   "type": "decal"
  },
  {
   "id": 284,
   "type": "decal"
  },
  {
   "id": 285,
   "type": "decal"
  },
  {
   "id": 313,
   "type": "decal"
  },
  {
   "id": 319,
   "type": "decal"
  },
  {
   "id": 320,
   "type": "decal"
  },
  {
   "id": 321,
   "type": "decal"
  },
  {
   "id": 323,
   "type": "decal"
  },
  {
   "id": 324,
   "type": "decal"
  },
  {
   "id": 325,
   "type": "decal"
  },
  {
   "id": 326,
   "type": "decal"
  },
  {
   "id": 327,
   "type": "decal"
  },
  {
   "id": 328,
   "type": "decal"
  },
  {
   "id": 329,
   "type": "decal"
  },
  {
   "id": 330,
   "type": "decal"
  },
  {
   "id": 331,
   "type": "decal"
  },
  {
   "id": 335,
   "type": "decal"
  },
  {
   "id": 336,
   "type": "decal"
  },
  {
   "id": 337,
   "type": "decal"
  },
  {
   "id": 340,
   "type": "decal"
  },
  {
   "id": 341,
   "type": "decal"
  },
  {
   "id": 342,
   "type": "decal"
  },
  {
   "id": 343,
   "type": "decal"
  },
  {
   "id": 344,
   "type": "decal"
  },
  {
   "id": 345,
   "type": "decal"
  },
  {
   "id": 346,
   "type": "decal"
  },
  {
   "id": 347,
   "type": "decal"
  },
  {
   "id": 348,
   "type": "decal"
  },
  {
   "id": 349,
   "type": "decal"
  },
  {
   "id": 350,
   "type": "decal"
  },
  {
   "id": 351,
   "type": "decal"
  },
  {
   "id": 352,
   "type": "decal"
  },
  {
   "id": 353,
   "type": "decal"
  },
  {
   "id": 354,
   "type": "decal"
  },
  {
   "id": 355,
   "type": "decal"
  },
  {
   "id": 356,
   "type": "decal"
  },
  {
   "id": 357,
   "type": "decal"
  },
  {
   "id": 358,
   "type": "decal"
  },
  {
   "id": 359,
   "type": "decal"
  },
  {
   "id": 360,
   "type": "decal"
  },
  {
   "id": 364,
   "type": "decal"
  },
  {
   "id": 365,
   "type": "decal"
  },
  {
   "id": 366,
   "type": "decal"
  },
  {
   "id": 367,
   "type": "decal"
  },
  {
   "id": 368,
   "type": "decal"
  },
  {
   "id": 369,
   "type": "decal"
  },
  {
   "id": 370,
   "type": "decal"
  },
  {
   "id": 371,
   "type": "decal"
  },
  {
   "id": 372,
   "type": "decal"
  },
  {
   "id": 373,
   "type": "decal"
  },
  {
   "id": 374,
   "type": "decal"
  },
  {
   "id": 375,
   "type": "decal"
  },
  {
   "id": 376,
   "type": "decal"
  },
  {
   "id": 402,
   "type": "decal"
  },
  {
   "id": 404,
   "type": "decal"
  },
  {
   "id": 407,
   "type": "decal"
  },
  {
   "id": 417,
   "type": "decal"
  },
  {
   "id": 418,
   "type": "decal"
  },
  {
   "id": 422,
   "type": "decal"
  },
  {
   "id": 432,
   "type": "decal"
  },
  {
   "id": 433,
   "type": "decal"
  },
  {
   "id": 436,
   "type": "decal"
  },
  {
   "id": 437,
   "type": "decal"
  },
  {
   "id": 438,
   "type": "decal"
  },
  {
   "id": 445,
   "type": "decal"
  },
  {
   "id": 446,
   "type": "decal"
  },
  {
   "id": 447,
   "type": "decal"
  },
  {
   "id": 451,
   "type": "decal"
  },
  {
   "id": 452,
   "type": "decal"
  },
  {
   "id": 453,
   "type": "decal"
  },
  {
   "id": 460,
   "type": "decal"
  },
  {
   "id": 461,
   "type": "decal"
  },
  {
   "id": 462,
   "type": "decal"
  },
  {
   "id": 466,
   "type": "decal"
  },
  {
   "id": 467,
   "type": "decal"
  },
  {
   "id": 468,
   "type": "decal"
  },
  {
   "id": 473,
   "type": "decal"
  },
  {
   "id": 474,
   "type": "decal"
  },
  {
   "id": 475,
   "type": "decal"
  },
  {
   "id": 481,
   "type": "decal"
  },
  {
   "id": 482,
   "type": "decal"
  },
  {
   "id": 483,
   "type": "decal"
  },
  {
   "id": 488,
   "type": "decal"
  },
  {
   "id": 489,
   "type": "decal"
  },
  {
   "id": 490,
   "type": "decal"
  },
  {
   "id": 496,
   "type": "decal"
  },
  {
   "id": 497,
   "type": "decal"
  },
  {
   "id": 498,
   "type": "decal"
  },
  {
   "id": 501,
   "type": "decal"
  },
  {
   "id": 502,
   "type": "decal"
  },
  {
   "id": 503,
   "type": "decal"
  },
  {
   "id": 511,
   "type": "decal"
  },
  {
   "id": 512,
   "type": "decal"
  },
  {
   "id": 513,
   "type": "decal"
  },
  {
   "id": 516,
   "type": "decal"
  },
  {
   "id": 517,
   "type": "decal"
  },
  {
   "id": 518,
   "type": "decal"
  },
  {
   "id": 522,
   "type": "decal"
  },
  {
   "id": 523,
   "type": "decal"
  },
  {
   "id": 524,
   "type": "decal"
  },
  {
   "id": 526,
   "type": "decal"
  },
  {
   "id": 527,
   "type": "decal"
  },
  {
   "id": 528,
   "type": "decal"
  },
  {
   "id": 529,
   "type": "decal"
  },
  {
   "id": 530,
   "type": "decal"
  },
  {
   "id": 531,
   "type": "decal"
  },
  {
   "id": 541,
   "type": "decal"
  },
  {
   "id": 542,
   "type": "decal"
  },
  {
   "id": 543,
   "type": "decal"
  },
  {
   "id": 544,
   "type": "decal"
  },
  {
   "id": 545,
   "type": "decal"
  },
  {
   "id": 546,
   "type": "decal"
  },
  {
   "id": 551,
   "type": "decal"
  },
  {
   "id": 552,
   "type": "decal"
  },
  {
   "id": 553,
   "type": "decal"
  },
  {
   "id": 554,
   "type": "decal"
  },
  {
   "id": 556,
   "type": "decal"
  },
  {
   "id": 557,
   "type": "decal"
  },
  {
   "id": 558,
   "type": "decal"
  },
  {
   "id": 559,
   "type": "decal"
  },
  {
   "id": 571,
   "type": "decal"
  },
  {
   "id": 572,
   "type": "decal"
  },
  {
   "id": 573,
   "type": "decal"
  },
  {
   "id": 574,
   "type": "decal"
  },
  {
   "id": 580,
   "type": "decal"
  },
  {
   "id": 581,
   "type": "decal"
  },
  {
   "id": 582,
   "type": "decal"
  },
  {
   "id": 583,
   "type": "decal"
  },
  {
   "id": 609,
   "type": "decal"
  },
  {
   "id": 610,
   "type": "decal"
  },
  {
   "id": 616,
   "type": "decal"
  },
  {
   "id": 617,
   "type": "decal"
  },
  {
   "id": 618,
   "type": "decal"
  },
  {
   "id": 619,
   "type": "decal"
  },
  {
   "id": 620,
   "type": "decal"
  },
  {
   "id": 621,
   "type": "decal"
  },
  {
   "id": 625,
   "type": "decal"
  },
  {
   "id": 626,
   "type": "decal"
  },
  {
   "id": 632,
   "type": "decal"
  },
  {
   "id": 633,
   "type": "decal"
  },
  {
   "id": 634,
   "type": "decal"
  },
  {
   "id": 635,
   "type": "decal"
  },
  {
   "id": 636,
   "type": "decal"
  },
  {
   "id": 637,
   "type": "decal"
  },
  {
   "id": 638,
   "type": "decal"
  },
  {
   "id": 639,
   "type": "decal"
  },
  {
   "id": 640,
   "type": "decal"
  },
  {
   "id": 642,
   "type": "decal"
  },
  {
   "id": 643,
   "type": "decal"
  },
  {
   "id": 644,
   "type": "decal"
  },
  {
   "id": 645,
   "type": "decal"
  },
  {
   "id": 646,
   "type": "decal"
  },
  {
   "id": 647,
   "type": "decal"
  },
  {
   "id": 648,
   "type": "decal"
  },
  {
   "id": 649,
   "type": "decal"
  },
  {
   "id": 650,
   "type": "decal"
  },
  {
   "id": 654,
   "type": "decal"
  },
  {
   "id": 655,
   "type": "decal"
  },
  {
   "id": 656,
   "type": "decal"
  },
  {
   "id": 658,
   "type": "decal"
  },
  {
   "id": 659,
   "type": "decal"
  },
  {
   "id": 660,
   "type": "decal"
  },
  {
   "id": 661,
   "type": "decal"
  },
  {
   "id": 662,
   "type": "decal"
  },
  {
   "id": 663,
   "type": "decal"
  },
  {
   "id": 664,
   "type": "decal"
  },
  {
   "id": 665,
   "type": "decal"
  },
  {
   "id": 666,
   "type": "decal"
  },
  {
   "id": 667,
   "type": "decal"
  },
  {
   "id": 668,
   "type": "decal"
  },
  {
   "id": 669,
   "type": "decal"
  },
  {
   "id": 670,
   "type": "decal"
  },
  {
   "id": 671,
   "type": "decal"
  },
  {
   "id": 672,
   "type": "decal"
  },
  {
   "id": 673,
   "type": "decal"
  },
  {
   "id": 674,
   "type": "decal"
  },
  {
   "id": 675,
   "type": "decal"
  },
  {
   "id": 676,
   "type": "decal"
  },
  {
   "id": 677,
   "type": "decal"
  },
  {
   "id": 678,
   "type": "decal"
  },
  {
   "id": 679,
   "type": "decal"
  },
  {
   "id": 683,
   "type": "decal"
  },
  {
   "id": 684,
   "type": "decal"
  },
  {
   "id": 685,
   "type": "decal"
  },
  {
   "id": 686,
   "type": "decal"
  },
  {
   "id": 687,
   "type": "decal"
  },
  {
   "id": 688,
   "type": "decal"
  },
  {
   "id": 689,
   "type": "decal"
  },
  {
   "id": 690,
   "type": "decal"
  },
  {
   "id": 691,
   "type": "decal"
  },
  {
   "id": 692,
   "type": "decal"
  },
  {
   "id": 693,
   "type": "decal"
  },
  {
   "id": 694,
   "type": "decal"
  },
  {
   "id": 695,
   "type": "decal"
  },
  {
   "id": 697,
   "type": "decal"
  },
  {
   "id": 708,
   "type": "decal"
  },
  {
   "id": 713,
   "type": "decal"
  },
  {
   "id": 724,
   "type": "decal"
  },
  {
   "id": 726,
   "type": "decal"
  },
  {
   "id": 736,
   "type": "decal"
  },
  {
   "id": 737,
   "type": "decal"
  },
  {
   "id": 742,
   "type": "decal"
  },
  {
   "id": 752,
   "type": "decal"
  },
  {
   "id": 753,
   "type": "decal"
  },
  {
   "id": 755,
   "type": "decal"
  },
  {
   "id": 756,
   "type": "decal"
  },
  {
   "id": 757,
   "type": "decal"
  },
  {
   "id": 764,
   "type": "decal"
  },
  {
   "id": 765,
   "type": "decal"
  },
  {
   "id": 766,
   "type": "decal"
  },
  {
   "id": 771,
   "type": "decal"
  },
  {
   "id": 772,
   "type": "decal"
  },
  {
   "id": 773,
   "type": "decal"
  },
  {
   "id": 780,
   "type": "decal"
  },
  {
   "id": 781,
   "type": "decal"
  },
  {
   "id": 782,
   "type": "decal"
  },
  {
   "id": 785,
   "type": "decal"
  },
  {
   "id": 786,
   "type": "decal"
  },
  {
   "id": 787,
   "type": "decal"
  },
  {
   "id": 792,
   "type": "decal"
  },
  {
   "id": 793,
   "type": "decal"
  },
  {
   "id": 794,
   "type": "decal"
  },
  {
   "id": 801,
   "type": "decal"
  },
  {
   "id": 802,
   "type": "decal"
  },
  {
   "id": 803,
   "type": "decal"
  },
  {
   "id": 808,
   "type": "decal"
  },
  {
   "id": 809,
   "type": "decal"
  },
  {
   "id": 810,
   "type": "decal"
  },
  {
   "id": 815,
   "type": "decal"
  },
  {
   "id": 816,
   "type": "decal"
  },
  {
   "id": 817,
   "type": "decal"
  },
  {
   "id": 818,
   "type": "decal"
  },
  {
   "id": 819,
   "type": "decal"
  },
  {
   "id": 820,
   "type": "decal"
  },
  {
   "id": 821,
   "type": "decal"
  },
  {
   "id": 822,
   "type": "decal"
  },
  {
   "id": 831,
   "type": "decal"
  },
  {
   "id": 832,
   "type": "decal"
  },
  {
   "id": 833,
   "type": "decal"
  },
  {
   "id": 834,
   "type": "decal"
  },
  {
   "id": 835,
   "type": "decal"
  },
  {
   "id": 836,
   "type": "decal"
  },
  {
   "id": 837,
   "type": "decal"
  },
  {
   "id": 838,
   "type": "decal"
  },
  {
   "id": 845,
   "type": "decal"
  },
  {
   "id": 846,
   "type": "decal"
  },
  {
   "id": 847,
   "type": "decal"
  },
  {
   "id": 848,
   "type": "decal"
  },
  {
   "id": 849,
   "type": "decal"
  },
  {
   "id": 850,
   "type": "decal"
  },
  {
   "id": 861,
   "type": "decal"
  },
  {
   "id": 862,
   "type": "decal"
  },
  {
   "id": 863,
   "type": "decal"
  },
  {
   "id": 864,
   "type": "decal"
  },
  {
   "id": 865,
   "type": "decal"
  },
  {
   "id": 866,
   "type": "decal"
  },
  {
   "id": 875,
   "type": "decal"
  },
  {
   "id": 876,
   "type": "decal"
  },
  {
   "id": 877,
   "type": "decal"
  },
  {
   "id": 878,
   "type": "decal"
  },
  {
   "id": 891,
   "type": "decal"
  },
  {
   "id": 892,
   "type": "decal"
  },
  {
   "id": 893,
   "type": "decal"
  },
  {
   "id": 894,
   "type": "decal"
  }
 ]
};